<template lang="pug">
    .parallax-image
        img(:src="img")
</template>

<script>
		
	import Vue from 'vue'
    import Component from 'vue-class-component'
    import $ from 'jquery'
	import { TweenMax } from 'gsap'
    import Scrollable from '~abstracts/scrollable'
    import Globals from '~utils/Globals'


  	@Component({
		name: 'PoliticalIntro',
		components: { },
		props: ["src"],
		data: function () {
			return {
				img: undefined
			}
		}
    })
    
    class ParallaxImage extends Scrollable {
        mounted () {
			super.mounted()

			this._dom()
        }
        
        init () {
			super.init()

			this.load()
		}

		load () {

			let bufferImg = new Image()
			bufferImg.onload = () => {
				this.img = this.src
			}
			bufferImg.src = this.src

		}

		initTimeline () {
            super.initTimeline()

            const total = this.boundsAnim.bottom - this.boundsAnim.top

            const durInOut = this.bounds.height/total


            this.tl.fromTo(this.$img,durInOut,{scale:1.1,y:-this.bounds.height*.2-10},{y:-10,scale:1.1, ease: Power0.easeNone},0)
            this.tl.to(this.$img,1 - durInOut*2,{y:10,scale:1.1, ease: Power0.easeNone},durInOut)
            this.tl.to(this.$img,durInOut,{scale:1.1,y:this.bounds.height*.2+10, ease: Power0.easeNone},1 - durInOut)
		}


		_dom () {
            this.$img = this.$el.querySelector('img')
        }
        
        raf (y) {
            super.raf(y)

		}

		_bind () {
			super._bind()
        }
        
        _resize () {
            super._resize()
            
			this.boundsAnim = {
				top: this.bounds.top - Globals.height,
				bottom: this.bounds.top + this.bounds.height
			}

			this.initTimeline()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
		}
    }

    export default ParallaxImage

</script>

<style lang="stylus">

    @import '../theme/utils'
	@import '../theme/variables'

    .parallax-image
        overflow hidden

</style>




// WEBPACK FOOTER //
// parallax-image.vue?55aad50f